import React from 'react';
import Layout from '../components/site/Layout';
import Button from '../components/site/Button';
import { CtaBanner } from '../components/site/PageParts';
import PlantScene from '../components/home/PlantScene';
import ProcessMap from '../components/home/ProcessMap';
import ThirdWay from '../components/home/ThirdWay';
import WhoBuilds from '../components/home/WhoBuilds';
import FullControl from '../components/home/FullControl';
import RecentWork from '../components/home/RecentWork';
import Faq from '../components/home/Faq';
import { LogoMarquee } from '../components/home/Sections';
import useLang from '../i18n/useLang';

function Hero() {
  const { t } = useLang();
  const areas = t('home.hero.areas', { returnObjects: true });
  return (
    <section className="relative isolate overflow-hidden border-b border-fog-200 bg-gradient-to-b from-fog-50 via-white to-white">
      <div
        aria-hidden="true"
        className="iso-grid absolute inset-0 -z-10 [mask-image:radial-gradient(ellipse_70%_80%_at_70%_40%,black,transparent)]"
      />
      <div className="wrap grid grid-cols-1 items-center gap-10 pb-14 pt-12 sm:pt-16 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.12fr)] lg:gap-10 lg:pb-16 lg:pt-14">
        <div className="max-w-xl">
          <h1 className="heading text-[2.2rem] leading-[1.08] text-ink motion-safe:animate-rise sm:text-[2.8rem] lg:text-[2.6rem] xl:text-[2.95rem]">
            {t('home.hero.title')}
          </h1>
          <p className="lead mt-6 max-w-[56ch] motion-safe:animate-rise [animation-delay:90ms]">{t('home.hero.lead')}</p>
          <div className="mt-9 flex flex-wrap gap-3 motion-safe:animate-rise [animation-delay:180ms]">
            <Button to="/contact" size="lg" arrow>
              {t('header.Contact')}
            </Button>
            <Button href="#how" size="lg" variant="secondary">
              {t('home.hero.how')}
            </Button>
          </div>
          <ul className="mt-10 flex flex-wrap gap-x-5 gap-y-2 border-t border-fog-200 pt-6 text-[0.9rem] font-medium text-ink-500 motion-safe:animate-rise [animation-delay:270ms]">
            {(Array.isArray(areas) ? areas : []).map((item) => (
              <li key={item} className="flex items-center gap-2">
                <span className="h-1.5 w-1.5 rounded-full bg-grovv-600" aria-hidden="true" />
                {item}
              </li>
            ))}
          </ul>
        </div>

        <div className="motion-safe:animate-rise [animation-delay:200ms]">
          <PlantScene />
        </div>
      </div>
    </section>
  );
}

const Home = () => (
  <Layout>
    <Hero />
    <LogoMarquee />
    <ProcessMap />
    <ThirdWay />
    <WhoBuilds />
    <FullControl />
    <RecentWork />
    <Faq />
    <CtaBanner />
  </Layout>
);

export default Home;
